import {
  registerApplication,
  start,
  LifeCycles,
  setMountMaxTime,
  setBootstrapMaxTime,
  pathToActiveWhen,
} from 'single-spa';
/**
 * Send specific, migrated routes to the Ionic application.
 */
const ionicPaths = [
  '/:marketSlug/refund/:filmSlug/:cinemaId/:vistaBookingId/summary',

  '/:marketSlug/theater/:theaterSlug',
  '/theater/:theaterSlug',
  '/:marketSlug/theater-bar/:theaterSlug',
  '/theater-bar/:theaterSlug',
  '/:marketSlug/bar-details/:theaterSlug',
  '/bar-details/:theaterSlug',

  '/:marketSlug/victory/seasonpass',
  '/:marketSlug/victory/seasonpass/success',
  '/:marketSlug/victory/seasonpass/register',
  '/:marketSlug/victory/seasonpass/subscribe',
  '/victory/seasonpass',
  '/victory/seasonpass/success',
  '/victory/seasonpass/register',
  '/victory/seasonpass/subscribe',

  '/victory',
  '/victory/faqs',
  '/victory/card-vault',
  '/victory/purchase-history',
  '/victory/tickets',
  '/victory/seasonpass-faqs',
  '/victory/victory-rewards',
  '/victory/forgot-password',
  '/victory/update-password',
  '/victory/reset-password/:resetCode',
  '/victory/complete-profile',
  '/victory/profile',
  '/:marketSlug/only-at-the-alamo',
  '/only-at-the-alamo',
  '/:marketSlug/offers',
  '/offers',
  '/home',
];

function hideLoader() {
  document.getElementById('sspa-loading').style.display = 'none';
}

registerApplication({
  name: '@drafthouse/adc-website',
  app: async () => {
    const singleSpaCss = await System.import('singleSpaCss');
    const singleSpaAngularjs = await System.import('singleSpaAngularjs');

    window['singleSpaCss'] = singleSpaCss;
    window['singleSpaAngularjs'] = singleSpaAngularjs.default;

    /**
     * Why this bad coding style of having a global variable alamo-drafthouse--globals?
     * The legacy adc-website needs to know the set of all adc-ui-ionic routes. If not it'll try to render those
     * routes and load a 404 page finally.
     *
     * Shouldn't this adc-ui-sspa-root app handle the routings?
     * Ideally yes.  But the legacy adc-website is so huge that manytimes adc-ui-sspa-root couldn't stop the adc-website routing
     * juggernaut. And adc-website wins the routing race.
     *
     * The Single SPA documentation talks about inter app communication features. Why can't make the adc-website and adc-ui-ionic
     * talk in a formal manner and share the ionic paths? Instead of sharing information through window globals?
     * We're working on that.
     *
     * How exactly the legacy adc-website uses these adcIonicPaths?
     * When it loads with these path, the AngularJs creates an empty app module. This empty AngularJs app doesn't do
     * anything, specifically no routing will happen at its end.
     *
     * Also, to prevent the adc-website from loading the ionic paths and angular paths at the same time when there is
     * a rollback in the mobile app via firebase flag, we check if the path has the chromeless=true query param. This
     * is a simple way to understand if the mobile-app is in rollback mode or not at this point in the request since
     * when a page is not present in the ionic code or has been rolled back, the Angular version will be loaded in the
     * iframe on the mobile app with a chromeless=true query param. We do this check in both applications so they don't
     * load the page in both apps since the path may be available in both even after the rollback.
     */

    if (!window['alamo-drafthouse--globals']) {
      window['alamo-drafthouse--globals'] = {
        adcIonicPaths: [...ionicPaths],
      };
    }

    return await System.import<LifeCycles>('@drafthouse/adc-website');
  },
  activeWhen: (location) =>
    !ionicPaths.some((angularPath) => pathToActiveWhen(angularPath, true)(location)) ||
    location?.search?.includes('chromeless=true'),
  customProps: (appName, location) => {
    return {
      isThisAppPath: !ionicPaths.some(
        (angularPath) =>
          pathToActiveWhen(angularPath, true)(location) ||
          location?.search?.includes('chromeless=true'),
      ),
    };
  },
});

registerApplication({
  name: '@drafthouse/adc-ui-ionic',
  app: () => System.import<LifeCycles>('@drafthouse/adc-ui-ionic'),
  activeWhen: (location) =>
    ionicPaths.some((angularPath) => pathToActiveWhen(angularPath, true)(location)) &&
    !location?.search?.includes('chromeless=true'),
});

start({
  urlRerouteOnly: true,
});

setMountMaxTime(60000, false, 70000);
setBootstrapMaxTime(60000, false, 70000);

window.addEventListener('single-spa:routing-event', () => {
  hideLoader();
  document.body.setAttribute('style', '');
});
window.addEventListener('single-spa:before-routing-event', () => {
  document.body.setAttribute('style', 'background: #090909');
});
